import { $ABTest } from '@lemon8/web-app-shared/atom';
import { Atom, atom } from 'jotai';
import _get from 'lodash/get';

export const $RelatedPostAIGCDesc: Atom<boolean> = atom((get) => {
  const { parameters } = get($ABTest);
  if (__BUILD_TYPE__ === 'local_dev') {
    return true;
  }
  console.log('libra info', parameters);
  return _get(parameters, ['seo_web', 'lemon8.related-post-image-aigc-description'], false);
});
